import React, { useState, memo, useEffect } from "react";
import ModalWrapper from "js/Component/ModalWrapper";

const AddEditEmailAction = (props) => {

    const { visible, onClose, onCancel, onEmailSubmitAction, selectedOption, customEmailText, questionText } = props;

    const [EmailSubject, setEmailSubject] = useState();
    const [EmailText, setEmailText] = useState("");
    const [activeTab, setActiveTab] = useState("email_recpt");
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const GetcustomActionField = (jsonString) => {
        try {
            const parsedData = JSON.parse(jsonString);
            if (parsedData && parsedData.email_id) {
                return parsedData.email_id;
            } else {
                return "";
            }
        } catch (error) {
            return "";
        }
    };

    const [emails, setEmails] = useState("");
    const [error, setError] = useState('');

    useEffect(() => {
        if (selectedOption != null) {
            let email = GetcustomActionField(selectedOption?.customAction)
            setEmails(email);

            let UpdateEmailText = customEmailText;
            UpdateEmailText = UpdateEmailText.replace("##Question##", questionText);
            UpdateEmailText = UpdateEmailText.replace("##Answer##", selectedOption.text);
            setEmailText(UpdateEmailText);

            let Subject = '##CareWindowName## selected, "##Answer##" on their CareWindow device'
            Subject = Subject.replace("##Answer##", selectedOption.text);
            setEmailSubject(Subject);
        }

    }, [selectedOption]);

    if (!visible) {
        return null;
    }

    const handleChange = (event) => {
        setEmails(event.target.value);
        setError(''); // Clear error on change
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateEmails()) {
            onEmailSubmitAction(selectedOption.id, {
                action: "send_alert_email",
                email_id: emails
            });

            onClose();
        }
    };

    const handleCancel = () => {
        onCancel();
    };

    const handleClose = () => {
        onClose();
    };

    const validateEmails = () => {
        const emailArray = emails.split(/\r?\n/).filter(email => email.trim() !== '')
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex

        let isValid = true;
        for (const email of emailArray) {
            if (!emailRegex.test(email)) {
                setError(`Invalid email format: ${email}`);
                isValid = false;
                break; // Stop at the first invalid email
            }
        }
        return isValid;
    };

    return (
        <>
            <ModalWrapper>
                <div className="modal-header">
                    <h1 className="modal-title">
                        Add Email Action
                        {/*{selectedOption?.finishingDesc ? "Edit finishing page" : "Add finishing page"}*/}
                    </h1>
                    <br />
                    <button className="close-button" onClick={handleCancel}> &times; </button>
                </div>
                <div className="modal-body">
                    <div className="tabbar" style={{ marginBottom: "20px" }}>
                        You may enter up to 6 email addresses, one per line. <br /><br />
                        <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist" >
                                <div className={`nav-item nav-link ${activeTab === "email_recpt" ? "active" : ""}`} onClick={() => handleTabClick("email_recpt")} >
                                    Recipients
                                </div>
                                <div className={`nav-item nav-link ${activeTab === "email_preview" ? "active" : ""}`} onClick={() => handleTabClick("email_preview")} >
                                    Email Preview
                                </div>
                            </div>
                        </nav>
                    </div>
                    <div>
                        {activeTab === "email_recpt" && (
                            <>
                                <label className="input-label">Email Addresses</label>
                                <textarea className="question-title-input" value={emails} onChange={handleChange} placeholder="enter email addresses"
                                    rows={4} style={{ resize: 'vertical', minHeight: '80px' }}
                                />
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                            </>
                        )}

                        {activeTab === "email_preview" && (
                            <>
                                <strong>{EmailSubject}</strong><br /><br />
                                <div dangerouslySetInnerHTML={{ __html: EmailText }} />
                            </>
                        )}
                    </div>
                    <div className="modal-actions" style={{ marginTop: "30px" }}>
                        <button className="cancel-btn" onClick={handleClose} > Cancel </button>
                        <button className="save-btn" onClick={handleSubmit} >
                            Save
                        </button>
                    </div>
                </div>
            </ModalWrapper>
        </>
    );
};

export default memo(AddEditEmailAction);
